// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"19bbdd45","787":"5a8c54cb"}[chunkId] + ".chunk.js";
};